import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { CategoryItem } from "./category-item"
import { TaskItem } from "./task-item"

export function ExplorerItem({ item }) {
    return (
        <If value={item.__isTask}>
            <TaskItem item={item} />
            <Else>
                <CategoryItem item={item} />
            </Else>
        </If>
    )
}
